/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_P2Inputs */

const tr_iade_iptal_s9_p2 = /** @type {(inputs: Iade_Iptal_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı, fesih bildirimi alındıktan sonra 3 (üç) iş günü içinde Abone'ye yazılı teyit gönderir.`)
};

const en_iade_iptal_s9_p2 = /** @type {(inputs: Iade_Iptal_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider sends the Subscriber a written confirmation within 3 (three) business days after receiving the termination notice.`)
};

const de_iade_iptal_s9_p2 = /** @type {(inputs: Iade_Iptal_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter sendet dem Abonnenten innerhalb von 3 (drei) Werktagen nach Zugang der Beendigungsmitteilung eine schriftliche Bestätigung.`)
};

const ru_iade_iptal_s9_p2 = /** @type {(inputs: Iade_Iptal_S9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик направляет Абоненту письменное подтверждение в течение 3 (трёх) рабочих дней после получения уведомления о расторжении.`)
};

/**
* | output |
* | --- |
* | "The Provider sends the Subscriber a written confirmation within 3 (three) business days after receiving the termination notice." |
*
* @param {Iade_Iptal_S9_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_p2 = /** @type {((inputs?: Iade_Iptal_S9_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_p2(inputs)
	if (locale === "de") return de_iade_iptal_s9_p2(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_p2(inputs)
	return tr_iade_iptal_s9_p2(inputs)
});